import postAPI from './postAPI.js'

export default async function postAssignTaskInstance(body) {
    const data = await postAPI('admin/taskinstances/assign', body);
    return data;
}
